import { render, staticRenderFns } from "./question-set-card.vue?vue&type=template&id=882b488c&scoped=true"
import script from "./question-set-card.vue?vue&type=script&lang=js"
export * from "./question-set-card.vue?vue&type=script&lang=js"
import style0 from "./question-set-card.vue?vue&type=style&index=0&id=882b488c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882b488c",
  null
  
)

export default component.exports